import React, { useRef, useEffect, useContext } from 'react';
import { string } from 'prop-types';

import { cn } from 'utils/style';
import { useIntersection } from 'hooks/intersection';
import { NavbarContext } from 'contexts/navbar';
import { EMPTY_FUNCTION } from 'constants/misc';

import './styles.scss';

function Section({ children, className, name, setCurrentSection, onView }) {
  const sectionRef = useRef(null);
  const [isVisible] = useIntersection(sectionRef);

  useEffect(() => {
    if (isVisible) {
      setCurrentSection(name);
      onView(name);
    }
  }, [isVisible, name, onView, setCurrentSection]);

  return (
    <section ref={sectionRef} id={name} className={cn('section', `section--${name}`, className)}>
      {children}
    </section>
  );
};

Section.propTypes = {
  name: string
}

Section.defaultProps = {
  setCurrentSection: EMPTY_FUNCTION,
  onView: EMPTY_FUNCTION,
}

function SectionContainer(props) {
  const { setCurrentSection } = useContext(NavbarContext);
  return <Section {...props} setCurrentSection={setCurrentSection} />
}

export default SectionContainer;
